<template>
  <div class="mx-12 mt-8">
    <MobilePlanFlashOffer
      v-if="offer.baseOffer"
      :base-offer="offer.baseOffer"
      :offer
    />
  </div>

  <MobilePlanOfferSelected v-if="selected" :offer />
</template>

<script setup lang="ts">
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'

import MobilePlanFlashOffer from '~/scopes/partnerships/components/MobilePlanFlashOffer/MobilePlanFlashOffer.vue'

import MobilePlanOfferSelected from './components/MobilePlanOfferSelected/MobilePlanOfferSelected.vue'

defineProps<{
  offer: MobilePlanOffer
  selected: boolean
}>()
</script>
